import { render, staticRenderFns } from "./DelegationRateMenu.vue?vue&type=template&id=19b88132&scoped=true&"
import script from "./DelegationRateMenu.vue?vue&type=script&lang=js&"
export * from "./DelegationRateMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b88132",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b88132')) {
      api.createRecord('19b88132', component.options)
    } else {
      api.reload('19b88132', component.options)
    }
    module.hot.accept("./DelegationRateMenu.vue?vue&type=template&id=19b88132&scoped=true&", function () {
      api.rerender('19b88132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/DelegationRate/DelegationRateMenu.vue"
export default component.exports